import { type Segment } from "../../lib/types/types";
import { studentMessages } from "../../lib/intl/messages/studentMessages";
import { teacherMessages } from "../../lib/intl/messages/teacherMessages";
import { memberMessages } from "../../lib/intl/messages/memberMessages";
import { militaryMessages } from "../../lib/intl/messages/militaryMessages";
import { seniorMessages } from "../../lib/intl/messages/seniorMessages";
import { firstResponderMessages } from "../../lib/intl/messages/firstResponderMessages";
import { medicalMessages } from "../../lib/intl/messages/medicalMessages";
import { ageMessages } from "../../lib/intl/messages/ageMessages";
import { employmentMessages } from "../../lib/intl/messages/employmentMessages";
import { identityMessages } from "../../lib/intl/messages/identityMessages";
import { licensedProfessionalMessages } from "../../lib/intl/messages/licensedProfessionalMessages";
import { moverMessages } from "../../lib/intl/messages/moverMessages";
import { lowIncomeMessages } from "../../lib/intl/messages/lowIncomeMessages";

type Messages = {
  default: string;
};

type HowDoesVerifyingWorkMessages = Record<Segment, Messages>;

export function howDoesVerifyingWorkMessages(): HowDoesVerifyingWorkMessages {
  return {
    student: {
      default: studentMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    teacher: {
      default: teacherMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    member: {
      default: memberMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    military: {
      default: militaryMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    senior: {
      default: seniorMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    firstResponder: {
      default: firstResponderMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    medical: {
      default: medicalMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    age: {
      default: ageMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    employment: {
      default: employmentMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    identity: {
      default: identityMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    licensedProfessional: {
      default: licensedProfessionalMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    recentMover: {
      default: moverMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
    lowIncome: {
      default: lowIncomeMessages.step.personalInfo.howDoesVerifyingWorkDetails,
    },
  };
}
